// ©2024 Austin App House. All rights reserved.
import React, { useState, useRef } from 'react';
import { isEmailValid, normalizePhoneInput } from '../../../../utils/validators';
import FormIconActions from '../../../dashboard/FormIconActions';

const ContractorInfoAddEdit = ({
    contractorToEdit = {},
    returnContractor,
    closeEdit,
    inputClassName,
}) => {
    const [mobile, setMobile] = useState(contractorToEdit?.mobile || '');
    const [officePhone, setOfficePhone] = useState(contractorToEdit?.ofc_phn || '');
    const [errors, setErrors] = useState({});

    const fnameRef = useRef(null);
    const roleRef = useRef(null);
    const emailRef = useRef(null);

    const specialCharRegex = /^[a-zA-Z0-9\s.,'-]*$/;

    const validateField = () => {
        const fname = fnameRef.current?.value || '';
        const role = roleRef.current?.value || '';
        const email = emailRef.current?.value || '';
        const newErrors = {};

        if (!fname.trim()) newErrors.fname = 'This field is required';
        else if (!specialCharRegex.test(fname)) newErrors.fname = 'Special characters are not allowed';

        if (role && !specialCharRegex.test(role)) newErrors.role = 'Special characters are not allowed';

        if (!email.trim()) newErrors.email = 'This field is required';
        else if (!isEmailValid(email)) newErrors.email = 'Invalid email address!';

        return newErrors;
    };

    const onSubmit = (event) => {
        event && event.preventDefault && event.preventDefault();
        const validationErrors = validateField();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            const result = {
                fname: fnameRef.current?.value || '',
                role: roleRef.current?.value || '',
                email: emailRef.current?.value || '',
                ofc_phn: officePhone,
                mobile: mobile,
            };
            returnContractor(result);
            if (fnameRef.current) fnameRef.current.value = '';
            if (roleRef.current) roleRef.current.value = '';
            if (emailRef.current) emailRef.current.value = '';
            setMobile('');
            setOfficePhone('');
            setErrors({});
        }
    };

    return (
        <div className="flex-box contact-form">
            <div className="fields_group">

                <div className="field_col">
                    <label className="field_name" htmlFor="fname">Name</label>
                    <div className="field_block">
                        <input
                            type="text"
                            name="fname"
                            id="fname"
                            maxLength={50}
                            defaultValue={contractorToEdit.fname || ''}
                            ref={fnameRef}
                            placeholder="Name"
                        />
                        {errors.fname && <div style={{ color: 'white', fontSize: '13px' }}>{errors.fname}</div>}
                    </div>
                </div>

                <div className="field_col">
                    <label className="field_name" htmlFor="role">Role</label>
                    <div className="field_block">
                        <input
                            type="text"
                            className={`small-input border-none-with-padding full-width ${inputClassName || ''}`}
                            name="role"
                            placeholder="Role"
                            defaultValue={contractorToEdit.role}
                            ref={roleRef}
                        />
                        {errors.role && <div style={{ color: 'white', fontSize: '13px' }}>{errors.role}</div>}
                    </div>
                </div>

                <div className="field_col">
                    <label className="field_name" htmlFor="email">Email</label>
                    <div className="field_block">
                        <input
                            type="email"
                            className={`small-input border-none-with-padding full-width ${inputClassName || ''}`}
                            name="email"
                            placeholder="Email"
                            defaultValue={contractorToEdit.email}
                            ref={emailRef}
                            required
                        />
                        {errors.email && <div style={{ color: 'white', fontSize: '13px' }}>{errors.email}</div>}
                    </div>
                </div>

                <div className="field_col">
                    <label className="field_name" htmlFor="ofc_phn">Office Phone</label>
                    <div className="field_block">
                        <input
                            type="phone"
                            className={`small-input border-none-with-padding full-width ${inputClassName || ''}`}
                            name="ofc_phn"
                            placeholder="Office Phone"
                            value={officePhone}
                            onChange={event => setOfficePhone(normalizePhoneInput(event.target.value))}
                        />
                    </div>
                </div>

                <div className="field_col">
                    <label className="field_name" htmlFor="mobile">Mobile</label>
                    <div className="field_block">
                        <input
                            type="phone"
                            className={`small-input border-none-with-padding full-width ${inputClassName || ''}`}
                            name="mobile"
                            placeholder="Mobile"
                            value={mobile}
                            onChange={event => setMobile(normalizePhoneInput(event.target.value))}
                        />
                    </div>
                </div>

                <div className="add_btns">
                    {
                        contractorToEdit.email
                            ? (
                                <FormIconActions
                                    centered
                                    onSave={onSubmit}
                                    onCancel={closeEdit}
                                />
                            )
                            : <button type="button" className="standard_btn icon_plus" onClick={onSubmit}>Add</button>
                    }
                </div>
            </div>
        </div>
    );
};

export default ContractorInfoAddEdit;
